import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UsersApi } from '../../../api/users/users.api';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';

import { ApiKeyApiModel, CreateApiKeyApiModel } from '../../../api/users/models/api-key.api.model';
import { ApiKey } from '../models/api-key';
@Injectable()
export class ApiKeyService {

    constructor(
        private usersApi: UsersApi,
    ) {}

    getApiKeys(accountId?: number): Observable<ApiKey[]> {
        const request = accountId ? this.usersApi.getAccountApiKeys(accountId) : this.usersApi.getApiKeys();
        return request.pipe(
            map(apiKeys => apiKeys.map(apiKey => new ApiKey(apiKey)))
        );
    }

    createApiKey(name: string, accountId?: number): Observable<ApiKeyApiModel> {
        const key: CreateApiKeyApiModel = {
            name,
            permissionIds: [userPermissionsEnum.mediaMonitoringApi]
        };
        const request = accountId ? this.usersApi.createAccountApiKey(accountId, key) : this.usersApi.createApiKey(key);
        return request;
    }

    updateApiKey(apiKey: ApiKey, accountId?: number): Observable<void> {
        const key: Partial<CreateApiKeyApiModel> = {
            name: apiKey.name,
            note: apiKey.note,
            permissionIds: [userPermissionsEnum.mediaMonitoringApi]
        };
        const request = accountId ? this.usersApi.updateAccountApiKey(accountId, apiKey.id, key) : this.usersApi.updateApiKey(apiKey.id, key);
        return request;
    }

    updateApiKeyStatus(apiKey: ApiKey, accountId?: number): Observable<void> {
        const key: Partial<CreateApiKeyApiModel> = {
            disabled: apiKey.disabled,
            permissionIds: [userPermissionsEnum.mediaMonitoringApi]
        };
        const request = accountId ? this.usersApi.updateAccountApiKey(accountId, apiKey.id, key) : this.usersApi.updateApiKey(apiKey.id, key);
        return request;
    }
}
